import { Injectable } from '@angular/core';
import { CookiePreferences } from '@interfaces/cookie-preferences';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CookiePreferencesService {

  private readonly cookieName = 'userCookiePreferences';

  constructor(private cookieService: CookieService) {}

  // Guardar preferencias del usuario
  savePreferences(preferences: CookiePreferences) {
    const preferencesJSON = JSON.stringify(preferences);
    this.cookieService.set(this.cookieName, preferencesJSON, 365, '/'); // Expira en 1 año
  }

  // Obtener las preferencias guardadas
  getPreferences(): CookiePreferences | null {
    const cookieValue = this.cookieService.get(this.cookieName);
    return cookieValue ? JSON.parse(cookieValue) : null;
  }

  // Verificar si el usuario ya ha aceptado cookies
  hasConsent(): boolean {
    return this.cookieService.check(this.cookieName);
  }

}
